import {
    FETCH_PLAYERS,
    FETCH_PLAYERS_FAIL,
    FETCH_PLAYERS_SUCCESS
} from './actionTypes';

export const fetchPlayers = args => ({
    type: FETCH_PLAYERS,
    payload: args || {}
});

export const fetchPlayersSuccess = response => ({
    type: FETCH_PLAYERS_SUCCESS,
    payload: response
});

export const fetchPlayersFail = error => ({
    type: FETCH_PLAYERS_FAIL,
    payload: error
});
